import React from 'react';
import { ChevronRight } from 'react-bootstrap-icons';

/**
 * Unique storage places for a product, in a green callout like Protocols.
 *
 * @param {Object} props
 * @param {Array<{ place: string, lots: string[], steps?: Array<{ name: string, emoji: string }> }>|null|undefined} props.groups
 */
const ProductLotLocations = ({ groups }) => {
  if (!groups) return null;
  return (
    <div className="open-procurement-callout product-locations-callout">
      <h6 className="open-procurement-callout__title">Locations</h6>
      {groups.length === 0 ? (
        <p className="text-muted mb-0">No lots on this product.</p>
      ) : (
        <ul className="product-locations-list">
          {groups.map(group => (
            <li key={group.place} className="product-locations-list__item">
              <span className="product-locations-list__text">
                <span className="product-locations-list__place" aria-label={group.place}>
                  {group.steps?.length ? (
                    group.steps.map((step, index) => (
                      <React.Fragment key={`${step.emoji}-${step.name}`}>
                        {index > 0 ? (
                          <ChevronRight className="product-locations-list__arrow" aria-hidden="true" />
                        ) : null}
                        <span className="product-locations-list__step">
                          <span className="product-locations-list__emoji" aria-hidden="true">
                            {step.emoji}
                          </span>
                          <span>{step.name}</span>
                        </span>
                      </React.Fragment>
                    ))
                  ) : (
                    group.place
                  )}
                </span>
                <span className="product-locations-list__lots">{group.lots.join(', ')}</span>
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ProductLotLocations;
